<template>
    <div>
        <div class="custom-search d-flex justify-content-end mb-1">
            <div class="float-left mr-auto">
                <b-button
                        variant="primary"
                        @click="newEntity"
                >
                    <span class="text-nowrap">Hozzáadás</span>
                </b-button>
            </div>
        </div>

        <!-- table -->
        <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="rows"
                :rtl="direction"
                :pagination-options="{
          enabled: true,
          perPage: pageLength
        }"
                :sort-options="{
          enabled: true,
          initialSortBy: sortBy
        }"
                @on-row-click="onRowClick"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
        >
            <div slot="emptystate">
                <div class="vgt-center-align vgt-text-disabled">
                    {{ $t('table.list.empty') }}
                </div>
            </div>
            <template
                    slot="table-row"
                    slot-scope="props"
            >

                <!-- Column: Name -->
                <span
                        v-if="props.column.field === 'name'"
                        class="text-nowrap"
                >
                <span class="text-nowrap">{{ props.row.name }}</span>
              </span>

                <span
                        v-else-if="props.column.field === 'status'"
                        class="text-nowrap"
                >
                <span class="text-nowrap">{{ $t('statuses.' + props.row.status) }}</span>
              </span>

                <span
                        v-else-if="props.column.field === 'date'"
                        class="text-nowrap"
                >
                <span class="text-nowrap" v-if="props.row.date">{{ props.row.date }}</span>
                <span class="text-nowrap" v-else>-</span>
              </span>

                <span
                        v-else-if="props.column.field === 'start_date'"
                        class="text-nowrap"
                >
                <span class="text-nowrap" v-if="props.row.start_date">{{ props.row.start_date }}</span>
                <span class="text-nowrap" v-else>-</span>
              </span>

                <span
                        v-else-if="props.column.field === 'end_date'"
                        class="text-nowrap"
                >
                <span class="text-nowrap" v-if="props.row.end_date">{{ props.row.end_date }}</span>
                <span class="text-nowrap" v-else>-</span>
              </span>

                <!-- Column: Action -->
                <span v-else-if="props.column.field === 'action'">
                <span v-if="$acl.canEditPermission(role)">
                  <copy-entity :id="props.row.id" type="document-library"/>
                  <b-button
                          size="sm"
                          variant="primary"
                          @click.stop="$router.push({ name: 'modify-document-library', params: { id: props.row.id }})"
                  >
                    <feather-icon
                            icon="EditIcon"
                    />
                  </b-button>
                </span>
                <span v-if="$acl.canDeletePermission(role)">
                  <b-button
                          size="sm"
                          variant="danger"
                          class="ml-1"
                          @click.stop="deleteEntity(props.row.id, $event)"
                  >
                    <feather-icon
                            icon="XCircleIcon"
                    />
                  </b-button>
                </span>
              </span>

                <!-- Column: Common -->
                <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- pagination -->
            <template
                    slot="pagination-bottom"
                    slot-scope="props"
            >
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              {{ ((page - 1) * pageLength) + 1 }} +
            </span>
                        <b-form-select
                                v-model="pageLength"
                                :options="pages"
                                class="mx-1"
                                @change="handlePageChange"
                        />
                        <span class="text-nowrap "> a {{ dataFromServer.total }} találatból </span>
                    </div>
                    <div>
                        <b-pagination
                                :value="1"
                                :total-rows="dataFromServer.total"
                                :per-page="dataFromServer.per_page"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="mt-1 mb-0"
                                @change="handleChangePage"
                        >
                            <template #prev-text>
                                <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
import {
    BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store/index'
import copyEntity from "@/views/pages/_components/_helper/CopyEntity";

export default {
    components: {
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BButton,
        copyEntity
    },
    data() {
        return {
            role: 'document_library',
            pageLength: 10,
            dir: false,
            pages: ['10', '20', '50'],
            columns: [
                {
                    label: this.$t('form.id'),
                    field: 'id',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Az. szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: this.$t('form.title'),
                    field: 'title',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Cím szerinti szűrés',
                    },
                },
                {
                    label: this.$t('form.type'),
                    field: 'translatedType',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Típus szerinti szűrés',
                        filterDropdownItems: [
                            {value: "document", text: "Dokumentum"},
                            {value: "news", text: "Hír"},
                            {value: "statistics", text: "Statisztika"},
                            {value: "rule", text: "Szabály"},
                            {value: "event", text: "Esemény"},
                        ]
                    },
                },
                {
                    label: 'Státusz',
                    field: 'status',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Státusz szerinti szűrés',
                        filterDropdownItems: [
                            {value: "draft", text: this.$t('statuses.draft')},
                            {value: "pending", text: this.$t('statuses.pending')},
                            {value: "publish", text: this.$t('statuses.publish')},
                        ]
                    },
                },
                {
                    label: 'Dátum',
                    field: 'date',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Dátum szerinti szűrés',
                    },
                },
                {
                    label: 'Kezdő időpont',
                    field: 'start_date',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Kezdő időpont szerinti szűrés',
                    },
                },
                {
                    label: 'Befejező időpont',
                    field: 'end_date',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Befejező időpont szerinti szűrés',
                    },
                },
            ],
            rows: [],
            page: 1,
            sortBy: {
                field: 'created_at',
                type: 'desc',
            },
            dataFromServer: [],
        }
    },
    computed: {
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    created() {
        let storedPageLength = localStorage.getItem('pageLength')
        if (storedPageLength) {
            this.pageLength = storedPageLength
        }

        if (this.$acl.canEditPermission(this.role) || this.$acl.canDeletePermission(this.role)) {
            const actions = [
                {
                    label: this.$t('table.header.actions'),
                    field: 'action',
                    sortable: false,
                    width: '15rem',
                },
            ]

            this.columns = [...this.columns, ...actions]
        }

        this.initEntities()
    },
    methods: {
        initEntities() {
            const searchParams = {
                page: parseInt(this.page),
                limit: parseInt(this.pageLength),
                query: this.searchTerm,
                columnFilters: this.columnFilters,
                sort: this.sortBy,
            }

            this.$store.dispatch('fetchDocumentLibraries', searchParams).then(response => {
                this.rows = response.data.entities.data
                this.dataFromServer = response.data.entities
                this.page = this.dataFromServer.current_page
                this.pageLength = parseInt(this.dataFromServer.per_page)
            })
        },
        onRowClick(params) {
            if (this.$acl.canEditPermission(this.role))
                this.$router.push({name: 'modify-document-library', params: {id: params.row.id}})
        },
        handleChangePage(page) {
            this.page = page
            this.initEntities()
        },
        handlePageChange(active) {
            this.pageLength = active
            localStorage.setItem('pageLength', active)
            this.page = 1
            this.handleChangePage()
        },
        newEntity() {
            this.$router.push({name: 'add-document-library'})
        },
        deleteEntity(id, event) {
            this.$bvModal
                .msgBoxConfirm('Biztosan törölni szeretnéd a dokumentumtár tételt?', {
                    title: 'Jóváhagyás',
                    size: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Igen',
                    cancelTitle: 'Nem',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if (value) {
                        // axios
                        this.$store.dispatch('deleteDocumentLibrary', id).then(() => {
                            this.initEntities(1)
                            this.$helpers.showSuccessToast(`Sikeres törlés (${id})`)
                        })
                    }
                })
        },
        onSortChange(params) {
            this.page = 1
            this.sortBy = params[0]
            this.initEntities()
        },
        onColumnFilter(params) {
            this.page = 1
            this.columnFilters = params.columnFilters
            this.initEntities()
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
